module.exports = ".primary-color {\n    color: #004b41;\n  }\n  .seconday-color {\n    color: #e5e5e5;\n  }\n  .text-paragraph {\n    font-size: 14px;\n  }"